import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'inscricoes-remover-comissao-dialog',
  template: `
    <h2 mat-dialog-title>Remover Examinador</h2>
    <mat-dialog-content>
      <p>Deseja remover <strong>{{ data.nome }}</strong> da comissão julgadora?</p>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Motivo da remoção (opcional)</mat-label>
        <textarea matInput [(ngModel)]="motivo" rows="3" maxlength="1000"></textarea>
        <mat-hint align="end">{{ motivo.length }}/1000</mat-hint>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>Cancelar</button>
      <button mat-raised-button color="warn" (click)="confirmar()">Remover</button>
    </mat-dialog-actions>
  `,
})
export class RemoverComissaoDialogComponent {
  motivo = ''

  constructor(
    public dialogRef: MatDialogRef<RemoverComissaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nome: string }
  ) {}

  confirmar(): void {
    this.dialogRef.close({ confirmed: true, motivo: this.motivo || null })
  }
}
